import React, { useEffect, useState } from 'react';
import { readinessApi } from '../services/api';
import { READINESS_META } from './ReadinessBadge';
import { CheckCircle2 } from 'lucide-react';

// "X of Y ready for dispatch" — the crew's morning go/no-go number.
export const ReadinessSummaryBanner = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    let on = true;
    readinessApi.getSummary().then(({ data }) => { if (on) setS(data); }).catch(() => {});
    return () => { on = false; };
  }, [refreshKey]);

  if (!s || s.total === 0) return null;
  const pct = s.total ? Math.round((s.ready / s.total) * 100) : 0;
  const chips = [
    ['green', s.green], ['amber', s.amber], ['red', s.red], ['grey', s.grey],
  ].filter(([, n]) => n > 0);

  return (
    <div
      data-testid="readiness-dispatch-banner"
      className="rounded-xl border border-border bg-card p-4 flex flex-col sm:flex-row sm:items-center gap-4"
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0"
             style={{ background: READINESS_META.green.bg, color: READINESS_META.green.text }}>
          <CheckCircle2 className="w-6 h-6" />
        </div>
        <div className="min-w-0">
          <div className="text-[18px] font-extrabold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
            <span data-testid="dispatch-ready-count">{s.ready}</span> of {s.total} ready for dispatch
          </div>
          <div className="text-xs text-muted-foreground">
            {pct}% of the fleet · {s.amber_dispatchable ? 'Green + Amber count as ready' : 'Green only counts as ready'}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {chips.map(([status, n]) => {
          const m = READINESS_META[status];
          return (
            <span key={status}
              className="inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-semibold"
              style={{ background: m.bg, borderColor: m.border, color: m.text }}
              data-testid={`dispatch-chip-${status}`}>
              <span className="w-2 h-2 rounded-full" style={{ background: m.dot }} />
              {n} {m.label}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default ReadinessSummaryBanner;
